module.exports = __webpack_public_path__ + "img/summer-min.05fae3f9.jpg";